<template>
  <div class="chapter chapter1">
    <video autoplay muted loop id="redVideo" :src="video">
    </video>
    <div v-if="slide === 1" class="blue-container">
      <Header v-bind:currentTimer="currentTimer" v-bind:strikes="collectedStrikes" :key="headerKey" />
      <div class="content-container">
        <div class="container pb-5">
          <div class="row justify-content-center">
            <div class="col-11 pt-5">
              <div class="newspaper">
                <div class="top"><img src="@/assets/newspaper-top.png" /></div>
                <div class="content">
                  <div class="row justify-content-center">
                    <div class="col-10 col-lg-8">
                      <h1 class="headline">{{ $t('chapter1.slide1.headline') }}</h1>
                    </div>
                  </div>
                  <div class="row justify-content-center pb-3">
                    <div class="col-10 col-lg-5">
                      <div class="text" v-html="$t('chapter1.slide1.text')"></div>
                    </div>
                    <div class="col-10 col-lg-3">
                      <img src="@/assets/queen.png" class="queen" />
                      <span class="image-subline">{{ $t('chapter1.slide1.image-subline') }}</span>
                    </div>
                  </div>
                </div>
                <div class="bottom"><img src="@/assets/newspaper-bottom.png" /></div>
              </div>
            </div>
          </div>
          <div class="row justify-content-center">
            <div class="col-8 col-sm-8 col-md-5 col-lg-4 pt-3 text-center">
              <form>
                <button class="btn btn-primary text-center" @click="navigateTo(2)">{{ $t('common.button.next') }}</button>
              </form>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
    <div v-if="slide === 2" class="blue-container">
      <Header v-bind:currentTimer="currentTimer" v-bind:strikes="collectedStrikes" :key="headerKey" />
      <div class="content-container">
        <div class="container h-100">
          <div class="row h-100">
            <div class="col-12 my-auto">
              <div class="row justify-content-center">
                <div class="col-10 col-sm-10 col-md-8 col-lg-5">
                  <h2 class="text-center">{{ $t('chapter1.slide2.headline') }}</h2>
                </div>
              </div>
              <div class="row justify-content-center">
                <div class="col-8 col-sm-8 col-md-5 col-lg-4 pt-3 text-center">
                  <form>
                    <button class="btn btn-primary text-center" @click="navigateTo(3)">{{ $t('common.button.next') }}</button>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
    <div v-if="slide === 3" class="blue-container">
      <Header v-bind:currentTimer="currentTimer" v-bind:strikes="collectedStrikes" :key="headerKey" />
      <div class="content-container">
        <div class="container h-100">
          <div class="row h-100">
            <div class="col-12 my-auto">
              <div class="row justify-content-center">
                <div class="col-10 col-sm-10 col-md-8 col-lg-6">
                  <h2 class="text-center">{{ $t('chapter1.slide3.headline') }}</h2>
                </div>
              </div>
              <div class="row justify-content-center">
                <div class="col-10 col-sm-10 col-md-10 col-lg-5 col-xl-4">
                  <form>
                    <div class="row form-group justify-content-center">
                      <div class="col-12 col-sm-12 col-md-5 col-lg-8">
                        <input type="text" class="form-control" v-model="riddles[0].input" />
                      </div>
                      <div class="col-6 col-sm-6 col-md-3 col-lg-4 pt-3 pt-md-0">
                        <button class="btn btn-primary" @click="checkSolution(0)">{{ $t('common.button.next') }}</button>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
      <div class="hints">
        <div class="container">
          <div class="row justify-content-center">
            <div class="col-12 text-center">
              <form>
                <div>
                  <span class="hints-text">{{ $t('common.hints') }} </span>
                  <button class="btn" @click="showHint(0, 0)">1</button>
                  <button v-if="riddles[0].hintsShown[0]" class="btn" @click="showHint(0, 1)">2</button>
                  <button v-if="riddles[0].hintsShown[1]" class="btn" @click="showHint(0, 2)">3</button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="riddles[0].showHint[0]" class="overlay" @click="closeHint">
      <div class="container h-100">
        <div class="row justify-content-center h-100">
          <div class="col-10 col-md-6 col-lg-4 my-auto hint-col blue p-5 h4 text-center">
            <img class="img-greetix" src="@/assets/greetix.png" />
          </div>
        </div>
      </div>
    </div>
    <div v-if="riddles[0].showHint[1]" class="overlay" @click="closeHint">
      <div class="container h-100">
        <div class="row justify-content-center h-100">
          <div class="col-10 col-md-6 col-lg-4 my-auto p-5 hint-col blue h4 text-center">
            {{ $t('chapter1.slide3.hints.2') }}
          </div>
        </div>
      </div>
    </div>
    <div v-if="riddles[0].showHint[2]" class="overlay" @click="closeHint">
      <div class="container h-100">
        <div class="row justify-content-center h-100">
          <div class="col-10 col-md-6 col-lg-4 my-auto hint-col blue p-5 h4 text-center">
            <img class="img-penny" src="@/assets/pennyknock.svg" />
          </div>
        </div>
      </div>
    </div>
    <div v-if="riddles[0].showSolution" class="overlay">
      <div class="container h-100">
        <div class="row justify-content-center h-100">
          <div class="col-10 col-md-6 col-lg-4 my-auto p-5 hint-col blue h4 solution">
            <strong>{{ $t('common.caution') }}!</strong><br />
            {{ $t('common.solutionText') }}<br />
            <br />
            <div class="solution"><strong>{{ $t('common.solutionLabel') }}<br />{{ riddles[0].solutionText }}</strong></div>
            <br />
            <button class="btn btn-primary" @click="nextRiddle">{{ $t('common.button.next') }}</button>
          </div>
        </div>
      </div>
    </div>
    <div v-if="slide === 4" class="blue-container">
      <Header v-bind:currentTimer="currentTimer" v-bind:strikes="collectedStrikes" :key="headerKey" />
      <div class="content-container">
        <div class="container h-100">
          <div class="row h-100">
            <div class="col-12 my-auto">
              <div class="row justify-content-center">
                <div class="col-10 col-sm-10 col-md-8 col-lg-5">
                  <h2 class="text-center" v-html="$t('chapter1.slide4.headline')"></h2>
                </div>
              </div>
              <div class="row justify-content-center">
                <div class="col-8 col-sm-8 col-md-5 col-lg-4 pt-3 text-center">
                  <form>
                    <div>
                      <button class="btn btn-primary" @click="navigateTo(5)">{{ $t('common.button.next') }}</button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
    <div v-if="slide === 5" class="red-container">
      <Header v-bind:currentTimer="currentTimer" v-bind:strikes="collectedStrikes" :key="headerKey" styleType="red" hideLogo="true" />
      <div class="content-container">
        <div class="container h-100">
          <div class="row h-100">
            <div class="col-12 my-auto">
              <div class="row justify-content-center">
                <div class="col-10 col-sm-10 col-md-8 col-lg-5 pb-5">
                  <img class="w-100" src="@/assets/TabbotSecurityLogo.svg" alt="Tabbot Security" />
                </div>
              </div>
              <div class="row justify-content-center">
                <div class="col-10 col-sm-10 col-md-8 col-lg-5 red-login text-center">
                  <img src="@/assets/red-login-avatar.png" alt="Login" />
                  <div class="row form-group justify-content-center">
                    <div class="col-8 pt-5 text-center">
                      <form>
                        <div v-if="currentRiddleError" class="error-msg pb-2">{{ $t('chapter1.slide5.errormsg') }}</div>
                        <input type="text" class="form-control text-center" v-model="riddles[1].input" :placeholder="$t('chapter1.slide5.password')" />
                        <button class="image-button" @click="checkSolution(1)"><img class="login-button" src="@/assets/ArrowButton.svg" :alt="$t('common.button.next')" /></button>
                      </form>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-12 text-center">
                      <span class="link" @click="showHint(1, 0)">{{ $t('chapter1.slide5.passwordForgotten') }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer type="red" />
    </div>
    <div v-if="riddles[1].showHint[0]" class="overlay" @click="closeHint">
      <div class="container h-100">
        <div class="row justify-content-center h-100">
          <div class="col-10 col-md-6 col-lg-4 my-auto p-5 hint-col red h4 text-center">
            {{ $t('chapter1.slide5.hints.1') }}
          </div>
        </div>
      </div>
    </div>
    <div v-if="riddles[1].showSolution" class="overlay">
      <div class="container h-100">
        <div class="row justify-content-center h-100">
          <div class="col-10 col-md-6 col-lg-4 my-auto p-5 hint-col red h4 solution">
            <strong>{{ $t('common.caution') }}!</strong><br />
            {{ $t('common.solutionText') }}<br />
            <br />
            <div class="solution"><strong>{{ $t('common.solutionLabel') }}<br />{{ riddles[1].solutionText }}</strong></div>
            <br />
            <button class="btn btn-danger" @click="nextRiddle">{{ $t('common.button.next') }}</button>
          </div>
        </div>
      </div>
    </div>
    <div v-if="slide === 6" class="red-container">
      <Header v-bind:currentTimer="currentTimer" v-bind:strikes="collectedStrikes" :key="headerKey" styleType="red" hideLogo="false" />
      <div class="content-container">
        <div class="container h-100">
          <div class="row h-100">
            <div class="col-12 my-auto">
              <div class="row justify-content-center">
                <div class="col-10 col-sm-10 col-md-10 col-lg-8 pb-3" v-html="$t('chapter1.slide6.statements')">
                </div>
              </div>
              <div class="row justify-content-center">
                <div class="col-10 col-sm-10 col-md-10 col-lg-8">
                  <img src="https://tabbot-central.b-cdn.net/images/Tischsitzung_Cam.jpg" class="w-100 pb-3" />
                </div>
              </div>
              <div class="row justify-content-center">
                <div class="col-10 col-sm-10 col-md-10 col-lg-8" v-html="$t('chapter1.slide6.text')">
                </div>
              </div>
              <div class="row justify-content-center">
                <div class="col-10 col-sm-10 col-md-10 col-lg-6 col-xl-5 pt-5">
                  <form>
                    <div class="row form-group justify-content-center">
                      <div class="col-12 col-sm-12 col-md-5 col-lg-8">
                        <input type="text" class="form-control" v-model="riddles[2].input" />
                      </div>
                      <div class="col-6 col-sm-6 col-md-3 col-lg-4 pt-3 pt-md-0">
                        <button class="btn btn-danger" @click="checkSolution(2)">{{ $t('common.button.next') }}</button>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer type="red" heads="true" />
      <div class="hints red">
        <div class="container">
          <div class="row justify-content-center">
            <div class="col-12 text-center">
              <form>
                <div>
                  <span class="hints-text">{{ $t('common.hints') }} </span>
                  <button class="btn" @click="showHint(2, 0)">1</button>
                  <button v-if="riddles[2].hintsShown[0]" class="btn" @click="showHint(2, 1)">2</button>
                  <button v-if="riddles[2].hintsShown[1]" class="btn" @click="showHint(2, 2)">3</button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="riddles[2].showHint[0]" class="overlay" @click="closeHint">
      <div class="container h-100">
        <div class="row justify-content-center h-100">
          <div class="col-10 col-md-6 col-lg-4 my-auto p-5 hint-col red h4 text-center">
            {{ $t('chapter1.slide6.hints.1') }}
          </div>
        </div>
      </div>
    </div>
    <div v-if="riddles[2].showHint[1]" class="overlay" @click="closeHint">
      <div class="container h-100">
        <div class="row justify-content-center h-100">
          <div class="col-10 col-md-6 col-lg-4 my-auto p-5 hint-col red h4 text-center">
            {{ $t('chapter1.slide6.hints.2') }}
          </div>
        </div>
      </div>
    </div>
    <div v-if="riddles[2].showHint[2]" class="overlay" @click="closeHint">
      <div class="container h-100">
        <div class="row justify-content-center h-100">
          <div class="col-10 col-md-6 col-lg-4 my-auto p-5 hint-col red h4 text-center">
            {{ $t('chapter1.slide6.hints.3') }}
          </div>
        </div>
      </div>
    </div>
    <div v-if="riddles[2].showSolution" class="overlay">
      <div class="container h-100">
        <div class="row justify-content-center h-100">
          <div class="col-10 col-md-6 col-lg-4 my-auto p-5 hint-col red h4 solution">
            <strong>{{ $t('common.caution') }}!</strong><br />
            {{ $t('common.solutionText') }}<br />
            <br />
            <div class="solution"><strong>{{ $t('common.solutionLabel') }}<br />{{ riddles[2].solutionText }}</strong></div>
            <br />
            <button class="btn btn-danger" @click="nextRiddle">{{ $t('common.button.next') }}</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import Header from '@/components/Header.vue'
import Footer from '@/components/Footer.vue'
import axios from 'axios'

export default {
  name: 'Chapter1',
  components: {
    Header, Footer
  },
  data: function () {
    return {
      pw: 'asdkfjhtmnbvasdfknedsfDSF',
      slide: 1,
      currentTimer: 0,
      currentRiddle: 0,
      currentRiddleError: false,
      chapter: 1,
      headerKey: 0,
      riddles: [
        {
          input: '',
          solutions: ['big bang theory', 'the big bang theory', 'bbt', 'tbbt'],
          solutionText: 'The Big Bang Theory',
          solutionTimer: 7,
          hintsShown: [false, false, false],
          showHint: [false, false, false],
          showSolution: false,
          causesStrikes: [true, true, true],
          strikeValues: [60, 60, 60],
          strikes: [0, 0, 0],
          riddleSlide: 3,
          nextSlide: 4
        },
        {
          input: '',
          solutions: ['trabant tbb', 'trabanttbb'],
          solutionText: 'Trabant TBB',
          solutionTimer: 3,
          hintsShown: [false],
          showHint: [false],
          showSolution: false,
          causesStrikes: [false],
          strikeValues: [0],
          strikes: [0],
          riddleSlide: 5,
          nextSlide: 6
        },
        {
          input: '',
          solutions: ['sheldon, bernadette', 'sheldon und bernadette', 'sheldon and bernadette', 'sheldon bernadette', 'bernadette, sheldon', 'bernadette und sheldon', 'bernadette and sheldon', 'bernadette sheldon'],
          solutionText: 'sheldon bernadette',
          solutionTimer: 10,
          hintsShown: [false, false, false],
          showHint: [false, false, false],
          showSolution: false,
          causesStrikes: [true, true, true],
          strikeValues: [60, 60, 60],
          strikes: [0, 0, 0],
          riddleSlide: 6,
          nextSlide: 7
        }
      ]
    }
  },
  computed: {
    video: function () {
      if (this.slide >= 5) return 'https://tabbot-central.b-cdn.net/video/BinaryNumbers2.mp4' // return require('@/assets/BinaryNumbers2.mp4')
      else return 'https://tabbot-central.b-cdn.net/video/BlauerHintergrundPlatine.mp4' // return require('@/assets/BlauerHintergrundPlatine.mp4')
    },
    collectedStrikes: function () {
      const strikes = []
      for (let r = 0; r < this.riddles.length; r++) {
        strikes.push(this.riddles[r].strikes)
      }
      return strikes
    }
  },
  methods: {
    calcTimer: function () {
      const d = new Date()
      let riddleTimer = 0
      for (let i = 0; i <= this.currentRiddle; i++) {
        riddleTimer += this.riddles[i].solutionTimer * 60
      }
      this.currentTimer = (this.$store.state.currentTimer + riddleTimer) - (d.getHours() * 3600 + d.getMinutes() * 60 + d.getSeconds())
      if (this.currentTimer > 0) {
        setTimeout(this.calcTimer, 500)
      } else {
        this.currentTimer = 0
        setTimeout(this.calcTimer, 500)
      }
      if (this.currentTimer === 0 && this.slide === this.riddles[this.currentRiddle].riddleSlide) {
        this.riddles[this.currentRiddle].showSolution = true
      }
    },
    navigateTo: function (slide) {
      event.preventDefault()
      this.slide = slide
    },
    checkSolution: function (riddle) {
      event.preventDefault()
      this.currentRiddleError = false
      if (this.riddles[riddle].solutions.includes(this.riddles[riddle].input.trim().toLowerCase())) {
        // Chapter finnished?
        if (this.currentRiddle + 1 >= this.riddles.length) {
          this.finishChapter()
          return
        }
        this.currentRiddle += 1
        this.slide = this.riddles[riddle].nextSlide
      } else {
        this.currentRiddleError = true
      }
    },
    saveHints: function () {
      const cookieDate = new Date()
      let expires = ';expires='
      cookieDate.setTime(cookieDate.getTime() + 86400000)
      expires += cookieDate.toGMTString()
      const strikes = []
      for (let r = 0; r < this.riddles.length; r++) {
        strikes.push(this.riddles[r].strikes)
      }
      document.cookie = 'strikes-' + this.chapter + '=' + JSON.stringify(strikes) + expires
    },
    showHint: function (riddle, hint) {
      event.preventDefault()
      this.riddles[riddle].showHint[hint] = true
      this.riddles[riddle].hintsShown[hint] = true
      this.riddles[riddle].strikes[hint] = this.riddles[riddle].strikeValues[hint]
      this.headerKey += 1
      this.saveHints()
    },
    closeHint: function () {
      for (const riddle in this.riddles) {
        for (const hint in this.riddles[riddle].showHint) {
          this.riddles[riddle].showHint[hint] = false
        }
      }
    },
    nextRiddle: function () {
      for (const riddle in this.riddles) {
        this.riddles[riddle].showSolution = false
      }
      this.slide = this.riddles[this.currentRiddle].nextSlide
      // Chapter finnished?
      if (this.currentRiddle + 1 >= this.riddles.length) {
        this.finishChapter()
      }

      this.currentRiddle += 1
    },
    finishChapter: function () {
      let strikes = 0
      for (let r = 0; r < this.riddles.length; r++) {
        for (let s = 0; s < this.riddles[r].strikes.length; s++) {
          strikes += this.riddles[r].strikes[s]
        }
      }
      this.currentTimer -= strikes
      if (this.currentTimer < 0) {
        this.currentTimer = 0
      }
      // SEND USER TO BACKEND
      axios.get('http://admin.tabbot-central.com/setChapterData.php', {
        params: {
          token: this.pw,
          username: this.$store.state.username,
          teamname: this.$store.state.teamname,
          chapter: 1,
          time: this.currentTimer
        }
      }).then(response => {
        console.log(response)
        this.$store.commit('updateGameState', 'beforeChapter2')
      }).catch(error => {
        console.log(error)
        this.errorType = 'couldNotLoginUser'
        this.loginError = true
      })
    }
  },
  created: function () {
    const cookies = document.cookie.split('; ').reduce((prev, current) => {
      const [name, value] = current.split('=')
      prev[name] = value
      return prev
    }, {})
    if (cookies['strikes-' + this.chapter]) {
      const strikes = JSON.parse(cookies['strikes-' + this.chapter])
      for (let r = 0; r < this.riddles.length; r++) {
        this.riddles[r].strikes = strikes[r]
      }
    }
    this.calcTimer()
  }
}
</script>
